export default __webpack_public_path__ + "static/media/Skyshear Helm.f51006af.jpg";